'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var ui = require('./components/root/ui.js');
var ui$9 = require('./components/divider/ui.js');
var ui$a = require('./components/spacer/ui.js');
var ui$b = require('./components/youtube/ui.js');
var ui$c = require('./components/countdown/ui.js');
var ui$d = require('./components/map/ui.js');
var ui$f = require('./components/gallery/ui.js');
var ui$g = require('./components/html-code/ui.js');
var ui$h = require('./components/page-flip/ui.js');
var ui$i = require('./components/number-counter/ui.js');
var ui$j = require('./components/social-icon/ui.js');
var ui$k = require('./components/store-list/ui.js');
var ui$l = require('./components/slider/v1/ui.js');
var ui$m = require('./components/table/ui.js');
var ui$p = require('./components/lucky-draw/v2/ui.js');
var ui$q = require('./components/testimonial-carousel/ui.js');
var ui$r = require('./components/websitefooter/ui.js');
var ui$s = require('./components/global-block/ui.js');
var ui$t = require('./components/website-header/ui.js');
var ui$u = require('./components/popuproot/ui.js');
var ui$v = require('./components/contact-bubble/ui.js');
var ui$w = require('./components/404/ui.js');
var ui$x = require('./components/product-list/ui.js');
var ui$y = require('./components/qr-code/ui.js');
var ui$z = require('./components/exam-score/ui.js');
var ui$A = require('./components/video/ui.js');
var ui$B = require('./components/article-list/ui.js');
var ui$C = require('./components/article-header/ui.js');
var ui$1 = require('./components/icon/ui.js');
var ui$2 = require('./components/section/ui.js');
var ui$3 = require('./components/container/ui.js');
var ui$4 = require('./components/row/ui.js');
var ui$5 = require('./components/col/ui.js');
var ui$6 = require('./components/button/v2/ui.js');
var ui$7 = require('./components/paragraph/ui.js');
var ui$8 = require('./components/heading/ui.js');
var ui$e = require('./components/image/ui.js');
var Accordion = require('./components/accordion/ui/Accordion.js');
var AccordionContent = require('./components/accordion/ui/AccordionContent.js');
var AccordionItem = require('./components/accordion/ui/AccordionItem.js');
var ListItemV2 = require('./components/list/v2/ui/ListItemV2.js');
var ListItemContentV2 = require('./components/list/v2/ui/ListItemContentV2.js');
var ListItemIconV2 = require('./components/list/v2/ui/ListItemIconV2.js');
var ui$n = require('./components/form/v4/ui.js');
var ui$o = require('./components/popup/v1/ui.js');
var Header = require('./components/header/ui/Header/Header.js');
var Menu = require('./components/header/ui/Menu/Menu.js');
var MenuItem = require('./components/header/ui/MenuItem/MenuItem.js');
var Logo = require('./components/header/ui/Logo/Logo.js');
var MenuCol = require('./components/header/ui/MenuCol/MenuCol.js');
var Tab = require('./components/tab/ui/Tab/Tab.js');
var TabItem = require('./components/tab/ui/TabItem/TabItem.js');
var TestimonialV2 = require('./components/testimonial/v2/ui/TestimonialV2/TestimonialV2.js');
var TestimonialItemV2 = require('./components/testimonial/v2/ui/TestimonialItemV2/TestimonialItemV2.js');
var ContentSlider = require('./components/content-slider/ui/ContentSlider/ContentSlider.js');
var ContentSliderItem = require('./components/content-slider/ui/ContentSliderItem/ContentSliderItem.js');
var ProductList = require('./components/teko-product-list/ui/ProductList/ProductList.js');
var ProductListContent = require('./components/teko-product-list/ui/ProductListContent/ProductListContent.js');

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const SubscriptionFormV2 = (props) => {
  return /* @__PURE__ */ jsxRuntime.jsx(ui$n.FormV4, __spreadValues({}, props));
};
SubscriptionFormV2.displayName = "SubscriptionFormV2";
const components = {
  Root: ui.Root,
  PbIcon: ui$1.PbIcon,
  Section: ui$2.PbSection,
  Container: ui$3.PbContainer,
  Row: ui$4.PbRow,
  Col: ui$5.PbCol,
  ButtonV2: ui$6.ButtonV2,
  Paragraph: ui$7.Paragraph,
  Heading: ui$8.Heading,
  Divider: ui$9.PbDivider,
  Spacer: ui$a.Spacer,
  Youtube: ui$b.Youtube,
  Countdown: ui$c.Countdown,
  Map: ui$d.Map,
  Image: ui$e.Image,
  Gallery: ui$f.Gallery,
  HtmlCode: ui$g.HtmlCode,
  PageFlip: ui$h.PageFlip,
  NumberCounter: ui$i.NumberCounter,
  SocialIcon: ui$j.SocialIcon,
  StoreList: ui$k.StoreList,
  Slider: ui$l.Slider,
  Table: ui$m.Table,
  Accordion: Accordion.Accordion,
  AccordionContent: AccordionContent.AccordionContent,
  AccordionItem: AccordionItem.AccordionItem,
  ListItemV2: ListItemV2.ListItemV2,
  ListItemContentV2: ListItemContentV2.ListItemContentV2,
  ListItemIconV2: ListItemIconV2.ListItemIconV2,
  FormV4: ui$n.FormV4,
  SubscriptionFormV2,
  PopupV1: ui$o.PopupV1,
  Header: Header.Header,
  Menu: Menu.Menu,
  MenuItem: MenuItem.MenuItem,
  Logo: Logo.Logo,
  MenuCol: MenuCol.MenuCol,
  LuckyDrawV2: ui$p.LuckyDrawV2,
  Tab: Tab.Tab,
  TabItem: TabItem.TabItem,
  TestimonialCarousel: ui$q.TestimonialCarousel,
  TestimonialV2: TestimonialV2.TestimonialV2,
  TestimonialV2Item: TestimonialItemV2.TestimonialV2Item,
  ContentSlider: ContentSlider.ContentSlider,
  ContentSliderItem: ContentSliderItem.ContentSliderItem,
  ProductList: ProductList.ProductList,
  ProductListContent: ProductListContent.ProductListContent,
  WebsiteFooter: ui$r.WebsiteFooter,
  GlobalBlock: ui$s.GlobalBlock,
  WebsiteHeader: ui$t.WebsiteHeader,
  PopupRoot: ui$u.PopupRoot,
  ContactBubble: ui$v.ContactBubble,
  Page404: ui$w.Page404,
  TempiProductList: ui$x.TempiProductList,
  QRCode: ui$y.QRCode,
  ExamScore: ui$z.ExamScore,
  Video: ui$A.Video,
  ArticleList: ui$B.ArticleList,
  ArticleHeader: ui$C.ArticleHeader
};

exports.components = components;
